import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { MenuIcon, XIcon } from 'lucide-react';
interface NavbarProps {
  onOpenOnboarding?: () => void;
}
export function Navbar({
  onOpenOnboarding
}: NavbarProps) {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    label: 'Curriculum',
    href: '#curriculum'
  }, {
    label: 'Mentors',
    href: '#mentors'
  }, {
    label: 'Testimonials',
    href: '#testimonials'
  }, {
    label: 'Pricing',
    href: '#pricing'
  }, {
    label: 'FAQ',
    href: '#faq'
  }];
  return <motion.nav initial={{
    y: -100
  }} animate={{
    y: 0
  }} transition={{
    duration: 0.6,
    ease: 'easeOut'
  }} className={`fixed top-0 left-0 right-0 transition-all duration-300 ${isScrolled ? 'bg-dark-900/90 backdrop-blur-xl border-b border-white/5' : 'bg-transparent'}`} style={{
    zIndex: 10000
  }} data-id="element-337">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-338">
        <div className="flex items-center justify-between h-20" data-id="element-339">
          {/* Logo */}
          <a href="#" className="flex items-center gap-3" data-id="element-340">
            <img src="https://cdn.magicpatterns.com/uploads/gh8LMhSDnKan7GYLYw8oaP/LeaDe_Brand_assets-01.svg" alt="LeaDe Academy" className="h-10 w-auto" data-id="element-341" />
          </a>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-1" data-id="element-342">
            {navLinks.map(link => <a key={link.label} href={link.href} className="px-4 py-2 text-sm text-gray-400 hover:text-white transition-colors duration-200" data-id="element-343">
                {link.label}
              </a>)}
          </div>

          {/* CTA Buttons */}
          <div className="hidden md:flex items-center gap-3" data-id="element-344">
            <button onClick={onOpenOnboarding} className="px-6 py-2.5 text-sm font-semibold bg-brand-yellow text-dark-900 rounded-full hover:bg-brand-yellow-dark transition-all duration-200 hover:scale-105" data-id="element-345">
              Enroll Now
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="md:hidden p-2 text-white" aria-label="Toggle menu" data-id="element-346">
            {isMobileMenuOpen ? <XIcon size={24} data-id="element-347" /> : <MenuIcon size={24} data-id="element-348" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence data-id="element-349">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-dark-800 border-t border-white/5" data-id="element-350">
            <div className="px-4 py-6 space-y-4" data-id="element-351">
              {navLinks.map(link => <a key={link.label} href={link.href} onClick={() => setIsMobileMenuOpen(false)} className="block px-4 py-2 text-gray-300 hover:text-white transition-colors" data-id="element-352">
                  {link.label}
                </a>)}
              <div className="pt-4 border-t border-white/10 space-y-3" data-id="element-353">
                <button onClick={() => {
              setIsMobileMenuOpen(false);
              if (onOpenOnboarding) onOpenOnboarding();
            }} className="block w-full text-center px-6 py-3 font-semibold bg-brand-yellow text-dark-900 rounded-full" data-id="element-354">
                  Enroll Now
                </button>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </motion.nav>;
}